<template>
  <section class="section page__content">
    <div class="page__row page__row--columns">
      <div class="page__column">
        <div class="page__item">
          <AppInput
            title="Название"
            :value="status.name"
            :valid="validation.name"
            required
            @value-changed="setName"
            @got-focus="clearValidation('name')"
            :disabled="!roleAccessEdit"
            width="250px"
          />
        </div>
      </div>

      <div class="page__column">
        <div class="page__item">
          <AppColorPicker
              title="Цвет:"
              :value="status.color"
              @value-changed="setColor"
              withDefaultsColors
              width="100%"
              :disabled="!roleAccessEdit"
            />
        </div>
      </div>
    </div>
    <div class="page__row page__row--columns">
      <div class="page__column">
        <div class="page__item">
          <AppSwitch title="Возможность переключить из любого состояния заказа"
                     @toggleCheck="setToggleManual"
                     :onCheck="status.is_manual"
                     :disabled="!roleAccessEdit"
          />
        </div>
        <div class="page__item">
          <AppSwitch title="В данном статусе заявка считается закрытой"
                     @toggleCheck="setToggleClose"
                     :onCheck="status.is_close"
                     :disabled="!roleAccessEdit"
          />
      </div>
        <div class="page__item">
          <AppSwitch title="Статус на котором происходит формирование договора"
                     @toggleCheck="setToggleShaping"
                     :onCheck="status.is_shaping"
                     :disabled="!roleAccessEdit"
          />
        </div>
        <div class="page__item">
          <AppSwitch title="Статус на котором происходит расчет стоимости"
                     @toggleCheck="setToggleCalculate"
                     :onCheck="status.is_calculate"
                     :disabled="!roleAccessEdit"
          />
        </div>
        <div class="page__item">
          <AppSwitch title="Сквозной статус"
                     @toggleCheck="setToggleThrough"
                     :onCheck="status.is_through"
                     :disabled="!roleAccessEdit"
          />
        </div>
        <div class="page__item">
          <AppSwitch title="Возможность отката"
                     @toggleCheck="setToggleRollback"
                     :onCheck="status.is_rollback"
                     :disabled="!roleAccessEdit"
          />
        </div>
      </div>

      <div class="page__column">
        <div class="page__item">
          <AppSelect title="Шаблон для отправки рабочему"
                      :options="[]"
                      :value="null"
                      @value-changed="() => {}"
                      :disabled="!roleAccessEdit"
          />
        </div>
        <div class="page__item">
          <AppSelect title="Шаблон для отправки клиенту"
                      :options="[]"
                      :value="null"
                      @value-changed="() => {}"
                      :disabled="!roleAccessEdit"
          />
        </div>
      </div>

    </div>

  </section>
</template>

<script>
import AppInput from '@/components/page/input/AppInput'
import AppSwitch from '@/components/page/input/AppSwitch'
import AppSelect from '@/components/page/input/AppSelect'
import AppColorPicker from '@/components/page/input/AppColorPicker'

export default {
  name: 'PvhStatusUpdateStatuses',
  components: {
    AppColorPicker,
    AppSelect,
    AppInput,
    AppSwitch
  },
  data () {
    return {
      selectedСolor: null
    }
  },
  computed: {
    status () {
      return this.$store.getters['[pvh] getStatusForUpdate']
    },
    validation () {
      return this.$store.getters['[pvh] getStatusUpdateValidation']
    },

    currentUser () {
      return this.$store.getters.currentUser
    },
    roleAccessEdit () {
      return this.$store.getters.getRoleRightPvh.actions.update
    }
  },
  methods: {
    setName (value) {
      this.$store.dispatch('[pvh] setStatusName', value)
    },
    setColor (value) {
      this.$store.dispatch('[pvh] setStatusColor', value)
    },
    setToggleManual () {
      this.$store.dispatch('[pvh] setStatusManual')
    },
    setToggleClose () {
      this.$store.dispatch('[pvh] setStatusClose')
    },
    setToggleShaping () {
      this.$store.dispatch('[pvh] setStatusShaping')
    },
    setToggleThrough () {
      this.$store.dispatch('[pvh] setStatusThrough')
    },
    setToggleRollback () {
      this.$store.dispatch('[pvh] setStatusRollback')
    },
    setToggleCalculate () {
      this.$store.dispatch('[pvh] setStatusCalculate')
    },

    clearValidation (inputName) {
      this.$store.dispatch('[pvh] statusUpdateClearValidation', inputName)
    }
  }
}
</script>

<style scoped>
.page__item {
  margin-bottom: 20px;
}

.page__row--columns {
  align-items: flex-start;
}
</style>
